export default __webpack_public_path__ + "static/media/Job.e64c2c16.svg";